import Image from 'next/image'
import { LandingPageSectionContainer } from '@/features/landing-page/landing-page-section-container'

export const LOGOS = [
    { name: 'Interface Capital', src: '/assets/landing-logo/interface.png', alt: 'Interface Capital logo' },
    { name: 'S16VC', src: '/assets/landing-logo/s16vc.png', alt: 'S16VC logo' },
    { name: 'Kapten & Son', src: '/assets/landing-logo/kapten_son.png', alt: 'Kapten and Son logo' },
    { name: 'Lovable', src: '/assets/landing-logo/lovable.png', alt: 'Lovable logo' },
    { name: 'OMR', src: '/assets/landing-logo/omr.png', alt: 'OMR logo' },
    { name: 'HelloFresh', src: '/assets/landing-logo/hellofresh.png', alt: 'HelloFresh logo' },
    { name: 'Lanch', src: '/assets/landing-logo/lanch.png', alt: 'Lanch logo' },
    { name: 'ElevenLabs', src: '/assets/landing-logo/elevenlabs.png', alt: 'ElevenLabs logo' },
    { name: 'Creandum', src: '/assets/landing-logo/creandum.png', alt: 'Creandum logo' },
] as const

function LogoBatch() {
    return (
        <div className="flex items-center gap-12 md:gap-16 shrink-0 py-1">
            {LOGOS.map((logo) => (
                <div
                    key={logo.name}
                    className="flex h-7 items-center justify-center opacity-65 grayscale hover:grayscale-0 hover:opacity-100 transition-all shrink-0"
                >
                    <Image
                        src={logo.src}
                        alt={logo.alt}
                        width={130}
                        height={28}
                        className="h-auto w-auto max-h-7 object-contain"
                    />
                </div>
            ))}
        </div>
    )
}

interface ILandingLogoCarouselSectionProps {
    title?: string
}

/** Pure CSS infinite scroll — no JavaScript. Two copies for seamless loop. */
export function LandingLogoCarouselSection({ title }: ILandingLogoCarouselSectionProps = {}) {
    return (
        <LandingPageSectionContainer>
            <div className="space-y-7">
                <h2 className="ds-section-label text-center px-5 lg:px-12">
                    {title ?? 'BACKED BY LEADING INVESTORS & COMPANIES'}
                </h2>

                <div className="max-w-[1548px] mx-auto relative overflow-hidden">
                    <div
                        className="absolute left-0 top-0 bottom-0 w-6 md:w-16 pointer-events-none z-10"
                        style={{
                            background: 'linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))',
                        }}
                    />
                    <div
                        className="absolute right-0 top-0 bottom-0 w-6 md:w-16 pointer-events-none z-10"
                        style={{ background: 'linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))' }}
                    />

                    <div
                        className="flex w-max items-center will-change-transform"
                        style={{ animation: 'logo-scroll 35s linear infinite' }}
                    >
                        <LogoBatch />
                        <div className="shrink-0 w-12 md:w-16" aria-hidden />
                        <LogoBatch />
                        <div className="shrink-0 w-12 md:w-16" aria-hidden />
                    </div>
                </div>
            </div>
        </LandingPageSectionContainer>
    )
}
